

export default {
  name: "ProductInfo",
  data() {
    return {
      loading: true,
      info: {
        auto: false,
        checked: 1,
      },
      // 商品信息
      productInfo: {}
    }
  },
  inject: ['reset'],
  created() {
    this.$route.query.auto === 'true' ? this.info.auto = true : this.info.auto = false
    this.getProductInfo()
  },
  methods: {
    // 返回
    onClickLeft() {
      window.history.back()
    },
    acomputed(data) {
      data.price - data.balance < 0 ? this.productInfo.shiji_price = 0 : this.productInfo.shiji_price = (data.price - data.balance)
    },
    // 获取商品信息
    async getProductInfo() {
      try {
        const {data} = await this.$http.post('/shop/shopquery', {
          id: this.$route.params.id,
          type: this.$route.query.type
        })
        if (data.status === 'success') {
          this.productInfo = data
          this.loading = false
          this.acomputed(data)
          this.$store.commit('setOther', {name: 'money', value: data.balance})
        } else {
          this.loading = false
          this.$notify({type:'danger',message:data.msg})
        }
      } catch (e) {
        this.$notify({type:'danger',message:'网络异常,请稍后重试'})
      }
    },
    // 立即购买
    async pay() {
      let params = {
        id: this.$route.params.id,
        type: this.$route.query.type,
        switch: this.info.checked,
        automatic_renewal: this.info.auto
      }
      this.loading = true
      const {data} = await this.$http.post('/shop/purchase', params)
      if (data.status === 'success') {
        if (data.msg === '购买成功') {
          this.loading = false
          this.$dialog.alert({
            title:'提示',
            message:data.msg,
          }).then(()=>{
            this.reset()
            this.$router.push('/mobile/mystuff')
            this.loading = false
          })
        } else {
          this.loading = false
          this.$router.push('/mobile/recharge')
          return this.$notify({type:'danger',message:'余额不足,请充值!'})
        }
      } else {
        this.loading = false
        this.$router.push('/mobile/mall')
        this.$notify({type:'danger',message:data.msg})
      }
    }
  }
}
